export default function MainContentLayout({ children }) {
  return (
    <div className="w-full flex-grow flex flex-col p-2">
      {children}
    </div>
  );
}
